import script from "./TopicCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicCardModal.vue?vue&type=script&setup=true&lang=js"

import "./TopicCardModal.vue?vue&type=style&index=0&id=0341e7a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0341e7a0"]])

export default __exports__